module.exports = __webpack_public_path__ + "static/assets/8ea23814ef4f6dc9f86859a028377a3a.svg";